import React, { createContext, useState, ReactNode } from 'react';
import { TemplateCreationData } from 'src/company/templates/types';
import { Company } from 'src/secret-menu/hooks/useCompanies';

type TemplateCreationContextType = {
  data: TemplateCreationData;
  setData: (data: TemplateCreationData) => void;
  updateData: (updates: Partial<TemplateCreationData>) => void;
  resetData: () => void;
};

const TemplateCreationContext = createContext<TemplateCreationContextType | undefined>(undefined);

export const initialTemplateCreationData: Omit<TemplateCreationData, 'company'> = {
  markdownSplitLevel: 2,
  sectionSplittingLevel: null,
  templateSections: [],
  templateName: '',
  templateDescription: '',
  extractedImagesCollection: null,
};

type Props = {
  children: ReactNode;
  company: Company;
};

export function TemplateCreationProvider({ children, company: defaultCompany }: Props) {
  const [data, setData] = useState<TemplateCreationData>({
    ...initialTemplateCreationData,
    company: defaultCompany,
  });

  const updateData = (updates: Partial<TemplateCreationData>) => {
    setData(prevData => ({ ...prevData, ...updates }));
  };

  const resetData = () => {
    setData({ ...initialTemplateCreationData, company: defaultCompany });
  };

  const value: TemplateCreationContextType = {
    data,
    setData,
    updateData,
    resetData,
  };

  return <TemplateCreationContext value={value}>{children}</TemplateCreationContext>;
}
